export const MERCURY = 'mercuryPlayer';
